export default "__VITE_ASSET__a9062d31__"